__turbopack_context__.v({
  "splitView": "SplitView-module__tFw0JW__splitView",
  "splitView33": "SplitView-module__tFw0JW__splitView33",
  "splitView50": "SplitView-module__tFw0JW__splitView50",
  "splitView66": "SplitView-module__tFw0JW__splitView66",
});
